(function() {
    angular
        .module("app")
        .controller("ExportDataModalController", ExportDataModalController)

        ExportDataModalController.$inject = [
        "$rootScope",
        "$scope",
        "$uibModalInstance",
        "title",
        "exportFunction"
    ]

    function ExportDataModalController(
        $rootScope,
        $scope,
        $uibModalInstance,
        title,
        exportFunction
    ){
        "use strict"

        $scope.startDate           = new Date()
        $scope.endDate             = $scope.startDate
        $scope.selectedStartDate   = $scope.startDate
        $scope.selectedEndDate     = $scope.endDate
        $scope.datePickerStartOpen = false
        $scope.datePickerEndOpen   = false
        $scope.format              = "MM/dd/yyyy"
        $scope.title               = title

        $scope.datePickerOptions = {
            formatYear:  "yy",
            startingDay: 1,
            showWeeks:   false
        }

        $scope.openDatePickerStart = function() {
            $scope.datePickerStartOpen = true
        }

        $scope.openDatePickerEnd = function() {
            $scope.datePickerEndOpen = true
        }

        $scope.setEndDate = (newDate) => {

            if (!newDate || newDate === "") {
                newDate = $scope.endDate
            }

            $scope.endDate           = newDate
            $scope.selectedEndDate   = $scope.endDate
            $scope.startDate         = moment($scope.endDate).subtract(6, "days").toDate()
            $scope.selectedStartDate = $scope.startDate

        }

        $scope.setStartDate = (newDate) => {

            if (!newDate || newDate === "") {
                newDate = $scope.startDate
            }

            $scope.startDate         = newDate
            $scope.selectedStartDate = $scope.startDate
            $scope.endDate           = moment($scope.startDate).add(6, "days").toDate()
            $scope.selectedEndDate   = $scope.endDate

        }

        $scope.setEndDate(new Date($rootScope.exportEndDate))

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }

        $scope.export = () => {
            $uibModalInstance.close(exportFunction($scope.endDate))
        }

    }
})()
